// 에삐 코스튬 카테고리 타입 — 동적 카테고리 시스템 (V201).
// 백엔드 DTO: backend/src/main/kotlin/app/aivoca/server/domain/admin/eppi/AdminCostumeCategoryData.kt

export type CostumeRenderKind =
    | 'CHARACTER'
    | 'BACKGROUND'
    | 'ARTIFACT'
    | 'TEXT_BUBBLE';

export const COSTUME_RENDER_KINDS: CostumeRenderKind[] = [
    'CHARACTER',
    'BACKGROUND',
    'ARTIFACT',
    'TEXT_BUBBLE',
];

export const RENDER_KIND_LABEL_KO: Record<CostumeRenderKind, string> = {
    CHARACTER: '캐릭터',
    BACKGROUND: '배경',
    ARTIFACT: '스티커',
    TEXT_BUBBLE: '말풍선',
};

export const RENDER_KIND_CHIP_COLOR: Record<
    CostumeRenderKind,
    'primary' | 'secondary' | 'info' | 'success'
> = {
    CHARACTER: 'primary',
    BACKGROUND: 'secondary',
    ARTIFACT: 'info',
    TEXT_BUBBLE: 'success',
};

/**
 * 카테고리 아이콘 코드 화이트리스트.
 * 모바일 `lib/common/widgets/costume_category_icon_map.dart` 키와 동기화.
 */
export interface CostumeCategoryIconOption {
    code: string;
    label: string;
}

export const COSTUME_CATEGORY_ICON_OPTIONS: CostumeCategoryIconOption[] = [
    {code: 'user', label: 'user (사용자/캐릭터)'},
    {code: 'sticker', label: 'sticker (스티커)'},
    {code: 'message', label: 'message (말풍선)'},
    {code: 'image', label: 'image (이미지/배경)'},
];

// ── 어드민 응답 / 요청 DTO ──────────────────────────────────────────────────────

export interface CostumeCategory {
    id: number;
    code: string;
    renderKind: CostumeRenderKind;
    displayNameKo: string;
    displayNameEn: string;
    displayNameJa: string;
    displayNameVi: string;
    iconCode: string | null;
    sortOrder: number;
    isActive: boolean;
    isSystem: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface CreateCostumeCategoryRequest {
    code: string;
    renderKind: CostumeRenderKind;
    displayNameKo: string;
    displayNameEn: string;
    displayNameJa: string;
    displayNameVi: string;
    iconCode?: string | null;
    sortOrder?: number;
    isActive?: boolean;
}

export interface PatchCostumeCategoryRequest {
    renderKind?: CostumeRenderKind;
    displayNameKo?: string;
    displayNameEn?: string;
    displayNameJa?: string;
    displayNameVi?: string;
    /** 빈 문자열이면 아이콘 클리어. null 이면 변경 없음. */
    iconCode?: string | null;
    sortOrder?: number;
    isActive?: boolean;
}

/** DELETE 409 응답 detail. */
export interface CategoryInUseDetail {
    categoryId: number;
    usedByCount: number;
}
